import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';


import 'owl.carousel'
import '../sass/style.scss'

import Splide from '@splidejs/splide';


const sliElements = document.querySelectorAll(".ssli");

sliElements.forEach((element) => {
  const dataRel = element.getAttribute("data-num");
  var main = new Splide( '.main-carousel-' + dataRel , {
      type      : 'fade',
      rewind    : true,
      pagination: false,
      arrows    : true,
      autoplay  : true,     // Włącz autoplay
    interval  : 7000,     // Przerwa między przejściami (w milisekundach)
    pauseOnHover: true,   // Zatrzymanie odtwarzania po najechaniu myszką
    pauseOnFocus: true,
    } );

  var thumbnails = new Splide( '.thumbnail-carousel-' + dataRel , {
      fixedWidth  : 188,
      fixedHeight : 120,
      gap         : 10,
      rewind      : true,
      arrows    : false,
      pagination  : false,
      isNavigation: false,
      breakpoints : {
        600: {
          fixedWidth : 60,
          fixedHeight: 44,
        },
      },
      autoplay  : true,     // Włącz autoplay
    interval  : 7000,     // Przerwa między przejściami (w milisekundach)
    pauseOnHover: true,   // Zatrzymanie odtwarzania po najechaniu myszką
    pauseOnFocus: true,
    } );

    main.sync( thumbnails );
    main.mount();
    thumbnails.mount();
});

/// accordions
const accordionItems = document.querySelectorAll('.wp-block-cgb-faq-item');

accordionItems.forEach(item => {
  const button = item.querySelector('.accordion-button');
  const collapse = item.querySelector('.accordion-collapse');
  const parentAccordion = item.closest('.wp-block-cgb-faq');

  button.addEventListener('click', () => {
    if (!collapse.classList.contains('show')) {
      const openItems = parentAccordion.querySelectorAll('.accordion-collapse.show');
      openItems.forEach(openItem => {
        const openButton = openItem.previousElementSibling.querySelector('.accordion-button');
        const isOpen = openButton.getAttribute('aria-expanded');
        openButton.setAttribute('aria-expanded', 'false');
        openItem.classList.remove('show');
      });
    }

    const isExpanded = button.getAttribute('aria-expanded');
    collapse.classList.toggle('show');
    button.setAttribute('aria-expanded', isExpanded === 'true' ? 'false' : 'true');
  });
});


/// tabs

// Function to activate tab and corresponding content
const activateTab = (tab, tabs, contents) => {
  const content = document.querySelector(`#${tab.id.replace('tab', 'content')}`);

  // Deactivate all tabs and contents
  tabs.forEach((t) => t.classList.remove('active'));
  contents.forEach((c) => c.classList.remove('active'));

  // Activate the tab and corresponding content
  tab.classList.add('active');
  if (content) content.classList.add('active');
};

// Get all tab groups
const tabContainers = document.querySelectorAll('.tabs-container');

tabContainers.forEach((container) => {
  const tabs = Array.from(container.querySelectorAll('.tab'));
  const contents = Array.from(container.querySelectorAll('.tab-content'));

  // Attach event listeners to tabs
  tabs.forEach((tab) => {
    tab.addEventListener('click', (event) => {
      const target = event.currentTarget;
      activateTab(target, tabs, contents);
    });
  });

  // Activate first tab on page load
  activateTab(tabs[0], tabs, contents);
});

document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.copy-btn');

  buttons.forEach(function (button) {
      button.addEventListener('click', function () {
          const textToCopy = button.getAttribute('data-copy');
          navigator.clipboard.writeText(textToCopy).then(function () {
              button.textContent = 'Skopiowano';
              setTimeout(function() {
                  button.textContent = 'Kopiuj';
              }, 2000); // Przywrócenie oryginalnego tekstu po 2 sekundach
          }).catch(function (error) {
              console.error('Błąd kopiowania', error);
          });
      });
  });
});



console.info('[wp-webpack-theme is live]')
